<template>
  <div
   
   
  >
  <div class="header-box-min header-box">
      <div class="menu-left">
        <div class="logo">
          <img
            src="../../assets/img/logo8.png"
            alt=""
            title="返回个人中心"
          />
        </div>
        <!-- <div @click="gotoURL" class="gotoJG" style="">进入机构账户中心</div> -->
      </div>

   
      
    </div>
    <div  class="signOutSuccess">
      <div class="content" v-if="type=== '0'">
      <div :class="['success']" class="imgBox">
        <i class="el-icon-check"></i>
      </div>
      <span
        style="display: inline-block;margin-left:10px;"
        class="fontStyle5"
        >{{ "操作成功" }}</span
      >
      <div style="width:756px;margin: 0 auto;margin-top:30px;text-align: left;">
        <span class="fontStyle6">{{
          "已收到您提交的账号注销请求，注销将于15日后正式生效。"
        }}</span
        ><br />
        <span class="fontStyle6">{{
          "在注销正式生效之前，如果您希望撤销注销请求，可以再次登录账号，根据提示选择撤销注销请求，本次注销请求将作废。"
        }}</span
        ><br />
        <span class="fontStyle6">{{ "再次感谢您的支持，谢谢!" }}</span
        ><br />
      </div>
    </div>

    <div class="content" v-else>
      <div :class="['success']" class="imgBox">
        <i class="el-icon-check"></i>
      </div>
      <span
        style="display: inline-block;margin-left:10px;"
        class="fontStyle5"
        >{{ "操作成功" }}</span
      >
      <div style="width:396px;margin: 0 auto;margin-top:30px;text-align: left;">
        <span class="fontStyle6">{{
          "已收到您提交的账号注销请求，注销将于1-5分钟后正式生效。"
        }}</span
        ><br />
        <span class="fontStyle6">{{ "再次感谢您的支持，谢谢!" }}</span
        ><br />
      </div>
    </div>
    </div>
    
    <div class="footer-box">
    <div class="footer">
      <div class="footer__body clearfix">
        <div class="footer__list">
          <div class="list__title"><span>关于我们</span></div>
          <div class="Dis--flex">
            <ul class="list__item">
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=aboutUs">关于我们</a>
              </li>
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=copyright">版权声明</a>
              </li>
              <!-- <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=aboutAccount">关于账号</a>
              </li>
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=aboutCard">关于会员卡</a>
              </li> -->
            </ul>
            <ul class="list__item">
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=list">帮助中心</a>
              </li>
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=aqservice">广告服务</a>
              </li>
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=aqnew">新媒体广告服务</a>
              </li>
              <!-- <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=consume">充值/消费</a>
              </li> -->
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=custom">客服/售后</a>
              </li>
            </ul>
            <ul class="list__item">
              <!-- <li><a href="javascript:void(0);" onclick="suggestWindow();">申述/建议</a></li> -->
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=webagreement">用户协议</a>
              </li>
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=agreement">会员协议</a>
              </li>
              <li>
                <a href="https://medjournals.cn/help/helpcenter.do?to=privacyclause">隐私条款</a>
              </li>
              <li>
                <a href="https://medjournals.cn/help/helpcenter.do?to=cookiepolicy">Cookie政策</a>
              </li>
              <!-- <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=suggest">申述/建议</a>
              </li>
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=custom">客服/售后</a>
              </li> -->
            </ul>
          </div>
        </div>
        <div class="footer__list">
          <div class="list__title"><span>联系我们</span></div>
          <div class="Dis--flex">
            <ul class="list__item">
              <li class="contact">
                联系电话：纸质期刊相关问题：010-51322386/2388
              </li>
              <li class="pddLeft"
                  style="padding-left: 110px">
                电子期刊/APP相关问题：010-51322487
              </li>
              <li class="email">客服邮箱：info@cmaph.org</li>
              <li class="weixin">在线客服：扫描关注二维码 或 <a href="https://cmaph.soboten.com/chat/pc/v2/index.html?sysnum=b3bcde969fc34532baa0bdb60d88f276&channelid=2" target="_blank">在线咨询</a></li>
              <!-- <li class="pddLeft"
                  style="padding-left: 40px">
                （微信号：cmaclub）或扫描右侧二维码
              </li> -->
            </ul>
          </div>
        </div>
        <div class="footer__list last">
          <div class="list__title"><span>关注菁医汇微信公众号微信号</span></div>
          <dl class="weixinBox">
            <dt>
              <img src="../../assets/img/qingyiweixin.jpg"
                   style="max-width: 120px" />
            </dt>
            <dd style="width: 120px">扫描关注公众号</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="footer__publishMsg">
      <div class="footer__publishMsg--inside">
        <p>
          <a href="https://beian.miit.gov.cn/"
             target="_blank"><span style="color: #fff">京ICP备</span><span style="color: #ff9900">07035254号-1</span></a>京公网安备<span>11010102000192号</span>出版物经营许可证<span>新出发京零字第东130025号</span>
        </p>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { Get, Put } from "@/api/axios";
export default {
  components: {},
  data() {
    return {
      height: window.document.body.clientHeight,
      type:''
    };
  },
  created() {
    console.log(
      window.document.body.clientHeight,
      "window.document.body.clientHeight"
    );
  },
  mounted() {
    this.type = this.getUrlParam('cancelStatus')
    console.log(this.type,'type12344444');
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
            history.pushState(null, null, document.URL);
    });
    // let url = encodeURIComponent(location.href);
    // console.log(url, "url--get");
    // let codes =
    //   window.location.protocol +
    //   "//" +
    //   window.location.host +
    //   "/member/cas/auth?redirectUrl=" +
    //   url;
    // console.log(codes, "codes--get");
    // console.log(
    //   localStorage.getItem("casLogin") + "?service=" + codes,
    //   "跳转的地址--get"
    // );
    // location.href =
    //   localStorage.getItem("casLogin") +
    //   "?service=" +
    //   encodeURIComponent(codes);
    // store.commit("clearCancelToken");
    // localStorage.removeItem("addLoginNameId");
    // localStorage.removeItem("time");
    // localStorage.removeItem("memberId");
    // localStorage.removeItem("addLoginName");
    // localStorage.removeItem("loginName");
    // localStorage.removeItem("gy");
    // localStorage.removeItem("uuid");
    // sessionStorage.clear();

    // setTimeout(() => {
    //   location.replace(location.href)
    // }, 500);
    
  },
  methods: {
    getUrlParam(name) {
      //构造一个含有目标参数的正则表达式对象
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      //匹配目标参数
      var r = window.location.search.substr(1).match(reg);
      //返回参数
      if (r != null) {
        return unescape(r[2]);
      } else {
        return null;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.header-box{
  min-width: 1200px;
    background: #016072;
    padding: 15px 0 15px 40px;
    height: 103px;
}
 .header-box-min {
    min-width: 1145px;
  }
  .menu-left {
    float: left;
    // width: 486px;
    margin-left: -6px;

    .logo {
      display: inline-block;
      vertical-align: middle;

      img {
        cursor: pointer;
        max-height: 66px;
      }
    }

    .n {
      display: inline-block;
      font-size: 18px;
      color: #fff;
      vertical-align: middle;
      position: relative;
      padding-left: 38px;
      margin-left: 45px;
      border-left: 0.5px solid #014e5f;
      height: 50px;
      line-height: 50px;
      cursor: pointer;
    }
  }
.signOutSuccess {
  background: rgb(245, 247, 248);
  padding-top: 20px;
  padding-bottom: 80px;
  height: 541px;
  .success {
    background: rgb(82, 196, 26) !important;
  }
  .content {
    text-align: center;
    margin: 0 auto;
    width: 1200px;
    height: 100%;
    background: #ffffff;
    border-radius: 0px 0px 4px 4px;
    padding-top: 120px;
  }
  .imgBox {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: inline-block;
    text-align: center;
    i {
      font-size: 20px;
      font-weight: bold;
      color: #ffffff;
      line-height: 32px;
      text-align: center;
    }
  }
  .fontStyle5 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    line-height: 40px;
  }
  .fontStyle6 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
  }
  .btnBox1 {
    text-align: center;
    padding-top: 30px;
  }
  .btns1 {
    width: 120px;
    height: 40px;
    border-radius: 20px;
    background-color: #52b8cc;
    font-size: 16px;
    line-height: 40px;
    margin: 0 15px;
    color: #fff;
    cursor: pointer;
    text-align: center;
    margin: auto;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 14px;
    border: none;
    &:hover {
      opacity: 0.8;
    }
  }
}
.footer-box {
  position: absolute;
  // bottom: 0px;
  left: 0;
  width: 100%;
  z-index: 1;
  // margin-top: 20px;
}
/* footer */
.footer {
  background: #016072;
  height: 310px;
}

.footer__body {
  width: 1200px;
  margin: 0 auto;
  padding-top: 35px;
}

.footer__list {
  float: left;
  width: 375px;
  margin-right: 110px;
}

.footer__list.last {
  width: 230px;
  margin-right: 0;
}

.footer__list .list__title {
  color: rgba(255, 255, 255, 0.7);
  padding: 15px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  font-size: 15px;
  margin-bottom: 20px;
}

.footer__list .Dis--flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
}

.footer__list .list__item {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.footer__list .list__item li {
  font-size: 13px;
  line-height: 30px;
  height: 30px;
  color: rgba(255, 255, 255, 0.5);
}

.footer__list .list__item li a {
  display: inline-block;
  background: url('../../../static/img/point.png') no-repeat left 6px center;
  padding-left: 15px;
  color: rgba(255, 255, 255, 0.5);
}
.footer__list .list__item li :hover {
  opacity: 0.8;
}
.footer__list .list__item li a:hover {
  color: #fff;
  opacity: 0.8;
  background: url('../../../static/img/point1.png') no-repeat left 6px center;
}

.footer__list .weixinBox dd {
  line-height: 30px;
  height: 30px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
}

.footer__list .weixinBox {
  padding: 0 20px 20px;
  width: 120px;
}

.footer__list .list__item li.contact {
  background: url('../../../static/img/publish_icon1.png') no-repeat left 10px
    center;
  padding-left: 45px;
}

.footer__list .list__item li.email {
  background: url('../../../static/img/publish_icon2.png') no-repeat left 10px
    center;
  padding-left: 45px;
}

.footer__list .list__item li.weixin {
  background: url('../../../static/img/publish_icon3.png') no-repeat left 10px
    center;
  padding-left: 45px;
  a{
	  background: none;
	  padding: 0;
	  text-decoration: underline;
  }
}

.footer__publishMsg {
  background-color: #015263;
  height: 45px;
  text-align: center;
  font-size: 12px;
  color: #fefefe;
  line-height: 45px;
}

.footer__publishMsg p {
  background: url('../../../static/img/footer_b.png') no-repeat left center;
  padding-left: 32px;
  display: inline-block;
  *display: inline;
  zoom: 1;
}

.footer__publishMsg span {
  color: #ff9900;
  margin-left: 9px;
  margin-right: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/signOutSuccess.vue